<template>
  <div>
    <md-table v-if="type === 'SRI'" class="table-proficiency-ranges">
      <md-table-row class="table-head">
        <md-table-cell colspan="3" class="uppercase">
          {{ $t("smi_sri.ranges") }}
        </md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 1</p>
            <p>190-530L</p>
          </div>
        </md-table-cell>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 5</p>
            <p>830-1010L</p>
          </div>
        </md-table-cell>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 9</p>
            <p>1050-1260L</p>
          </div>
        </md-table-cell>
      </md-table-row>
      <md-table-row>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 2</p>
            <p>420-650L</p>
          </div>
        </md-table-cell>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 6</p>
            <p>925-1070L</p>
          </div>
        </md-table-cell>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 10</p>
            <p>1080-1335L</p>
          </div>
        </md-table-cell>
      </md-table-row>
      <md-table-row>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 3</p>
            <p>520-820L</p>
          </div>
        </md-table-cell>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 7</p>
            <p>970-1120L</p>
          </div>
        </md-table-cell>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 11</p>
            <p>1185-1385L</p>
          </div>
        </md-table-cell>
      </md-table-row>
      <md-table-row>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 4</p>
            <p>740-940L</p>
          </div>
        </md-table-cell>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 8</p>
            <p>1010-1185L</p>
          </div>
        </md-table-cell>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 12</p>
            <p>1185-1385L</p>
          </div>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-table v-if="type === 'SMI'" class="table-proficiency-ranges">
      <md-table-row class="table-head">
        <md-table-cell colspan="3" class="uppercase">
          {{ $t("smi_sri.ranges") }}
        </md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>
          <div class="grade-score">
            <p class="mr-2">{{ $t("common.grade") }} K</p>
            <p>9-117Q</p>
          </div>
        </md-table-cell>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 5</p>
            <p>645-771Q</p>
          </div>
        </md-table-cell>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 10</p>
            <p>1216-1248Q</p>
          </div>
        </md-table-cell>
      </md-table-row>
      <md-table-row>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 1</p>
            <p>117-232Q</p>
          </div>
        </md-table-cell>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 6</p>
            <p>785-890Q</p>
          </div>
        </md-table-cell>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 11</p>
            <p>1216-1248Q</p>
          </div>
        </md-table-cell>
      </md-table-row>
      <md-table-row>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 2</p>
            <p>271-382Q</p>
          </div>
        </md-table-cell>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 7</p>
            <p>881-970Q</p>
          </div>
        </md-table-cell>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 12</p>
            <p>1216-1248Q</p>
          </div>
        </md-table-cell>
      </md-table-row>
      <md-table-row>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 3</p>
            <p>381-545Q</p>
          </div>
        </md-table-cell>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 8</p>
            <p>1001-1089Q</p>
          </div>
        </md-table-cell>
      </md-table-row>
      <md-table-row>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 4</p>
            <p>534-629Q</p>
          </div>
        </md-table-cell>
        <md-table-cell>
          <div class="grade-score">
            <p>{{ $t("common.grade") }} 9</p>
            <p>1133-1214Q</p>
          </div>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>
<script>
export default {
  name: "table-proficiency-ranges",
  props: ["type"]
};
</script>
<style lang="scss">
.table-proficiency-ranges {
  .md-table-cell.uppercase,
  .table-head:hover {
    text-align: center;
    background-color: #3e6e98;
    border: 1px solid #3e6e98;
    .md-table-cell-container {
      color: #ffffff;
      font-weight: 500;
    }
  }
  .md-table-cell {
    border: 1px solid #b4c3c3;
  }
  .grade-score {
    @apply text-sm md:flex md:justify-around;
  }
}
</style>
